import isAbsoluteURL from "../helpers/isAbsoluteURL.mjs";
import combineURLs from "../helpers/combineURLs.mjs";
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
export {
  buildFullPath as default
};
